var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.graph.radio===2)?_c('display-ring',{attrs:{"graph":_vm.graph,"extend":_vm.chartExtendRing,"data":_vm.chartData}}):_c('display-pie',{attrs:{"graph":_vm.graph,"extend":_vm.chartExtend,"data":_vm.chartData,"nodata":_vm.flag}})}
var staticRenderFns = []

export { render, staticRenderFns }